export const UserRatesErrors = {
    EFFECTIVE_DATE_EMPTY: "effectiveDateEmpty",
    EFFECTIVE_DATE_DUPLICATE: "effectiveDateDuplicate",
    REGULAR_RATE_EMPTY: "regularRateEmpty",
    REGULAR_RATE_INVALID:"regularRateInvalid",
    OVERTIME_RATE_EMPTY: "overtimeRateEmpty",
    OVERTIME_RATE_INVALID: "overtimeRateInvalid",
    LEAVE_RATES_EMPTY: "leaveRatesEmpty",
    LEAVE_RATES_INVALID: "leaveRatesInvalid",

    RATE_EMPTY: "rateEmpty",
    RATE_INVALID: "rateInvalid",
}

export const ShowWarning = {
    EFFECTIVE_DATE_WARNING: "effectiveDateWarning",
    REGULAR_RATE_WARNING: "regularRateWarning",
    OVERTIME_RATE_WARNING: "overtimeRateWarning",
    LEAVE_RATES_WARNING: "leaveRatesWarning",
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/userRates/constants.js